import { render } from "./MultiBoxPlan.vue?vue&type=template&id=340a3795&scoped=true"
import script from "./MultiBoxPlan.vue?vue&type=script&lang=js"
export * from "./MultiBoxPlan.vue?vue&type=script&lang=js"

import "./MultiBoxPlan.vue?vue&type=style&index=0&id=340a3795&scoped=true&lang=css"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340a3795"]])

export default __exports__